import React, { useState } from 'react'
import RejectPopupIcon from '../../Images/RejectPopupIcon.svg';
// import {URL} from '../../config.json'
import axios from 'axios';
import config from "../../config.json";

const { URL } = config;
// let URL = "https://api.orgzstack.com/v1/"; 
// let URL = "http://localhost:9000/v1/";


function RejectPopup({params, isRejected, handleCloseModel, openSaveButton, close, setOpen2, SaveButton, setOpenSaveButton, empl, candidateShareData, particularCandidateData, setRenderKey, handleClose2 }) {
  const [message, setMessage] = useState()
  console.log('checscdf', candidateShareData, particularCandidateData)
  const handleChangeStatusReject = async () => {
    try {
      console.log('Check data in line no. 1632', particularCandidateData, empl, candidateShareData);

      const payload = {
        email: particularCandidateData.EmailId,
        requisitionId: candidateShareData.requisitionId || params?.requisitionId,
        statusUpdate: [
          { requisitionId: candidateShareData.requisitionId, message: message, Status: "Reject" },
        ],
      };

      const response = await axios.put(`${URL}employee/candidateStatusUpDate`, payload);
      
      localStorage.setItem('EmailId', response.data.updatedCandidate.email);
      console.log('Candidate rejected successfully', response.data, response?.data?.updatedCandidate);
      // handleClose2();
      // // Show the "openSaveButton" modal
      setOpenSaveButton(true);

      // // Close the "openSaveButton" modal after 1 second
      setTimeout(() => {
        setOpenSaveButton(false); // Close the save confirmation modal
        isRejected(response?.data?.updatedCandidate?.email)

        // Close the RejectPopup modal


        // Optional: Call handleCloseModel() if necessary
        handleCloseModel();

        // Refresh the parent view if needed
        setRenderKey((prevKey) => prevKey + 1);
      }, 2000);

    } catch (error) {
      console.error('Error rejecting candidate', error);
      // Handle error (e.g., show a toast message or alert)
    }
  };




  // const handleChangeStatusReject = async () => {
  //   // const confirmation = window.confirm("Are you sure you want to reject this candidate?");

  //   // if (confirmation) {
  //   try {
  //     console.log('Check data in line no. 1632', particularCandidateData, empl, candidateShareData);

  //     const payload = {
  //       email: particularCandidateData.EmailId,
  //       requisitionId: candidateShareData.requisitionId,
  //       statusUpdate: [
  //         { requisitionId: candidateShareData.requisitionId, message: message, Status: "Reject" },
  //       ],
  //     };

  //     const response = await axios.put(`${URL}employee/candidateStatusUpDate`, payload);
  //     console.log('Candidate rejected successfully', response.data);
  //     setOpenSaveButton(true)
  //     setTimeout(() => {
  //       setOpenSaveButton(false)
  //       handleCloseModel()
  //     }, 1000)
  //     handleCloseModel()

  //     setRenderKey((prevKey) => prevKey + 1);
  //     // setOpenSaveButton(true)
  //     setOpen2(false)
  //     close()
  //     //   alert('Candidate rejected successfully!');
  //   } catch (error) {
  //     console.error('Error rejecting candidate', error);
  //     //   alert('Failed to reject candidate. Please try again.');
  //   }
  //   // } else {
  //   //    console.log("Rejection canceled by the user.");
  //   // }
  // };
  return (
    <div
      style={{
        width: '100%',
        maxWidth: '420px',
        height: 'auto',
        maxHeight: '400px',
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        borderRadius: '20px',
        border: '1px solid #E7E7E7',
        backgroundColor: 'white',
        boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
        fontFamily: 'Lexend, sans-serif',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '24px',
        boxSizing: 'border-box',
      }}
    >

      <div style={{ textAlign: 'center' }}>
        <img
          src={RejectPopupIcon}
          alt="Reject Icon"
          style={{ width: '48px', height: '50px', color: '#4DB53A' }}
        />
      </div>


      <div
        style={{
          textAlign: 'center',
          fontSize: '16px',
          fontWeight: '500',
          color: '#242424',
          lineHeight: '18.23px',
          marginTop: '16px',
        }}
      >
        Let us know the reason for rejecting this candidate
      </div>


      <div
        style={{
          width: '100%',
          marginTop: '16px',
        }}
      >
        <textarea
          placeholder="Enter description here"
          value={message}
          onChange={(event) => setMessage(event.target.value)}
          style={{
            width: '100%',
            height: '100px',
            border: '1px solid #E7E7E7',
            borderRadius: '10px',
            padding: '10px',
            fontFamily: 'Lexend, sans-serif',
            fontSize: '14px',
            color: '#242424',
            resize: 'none',
            outline: 'none',
            boxSizing: 'border-box',
          }}
        />
      </div>
      <button
        onClick={handleChangeStatusReject}
        style={{
          width: '100%',
          height: '40px',
          backgroundColor: '#3C78D8',
          color: 'white',
          borderRadius: '10px',
          border: 'none',
          fontSize: '14px',
          fontWeight: '500',
          cursor: 'pointer',
          marginTop: '16px',
        }}
      >
        Save
      </button>

    </div>

  )
}

export default RejectPopup



















